
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/financial-planning-hero.webp';
import highResMobileImageWebp from './images/financial-planning-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='financial-planning-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Financial Planning'
      headingText={<>What&#39;s a financial <WidowBlock>plan, exactly&#63;</WidowBlock></>}
      descriptionText={<>Some people think it&#39;s a retirement plan. Others a budget. We&#39;re here to clear things up. Get a glimpse into how we create a financial plan and what yours could look like.</>}
      ctaPrimary={{
        linkUrl: '/financial-planning/sample-financial-plan-tour/?a=1',
        buttonText: 'Take a quick tour',
        ariaLabel: 'Take a quick tour on how your sample financial plan would come together.',
        children: '',
      }}
      backgroundImageAriaLabel='Two women sitting on a front porch with tea'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
